import { Grid, Typography } from '@mui/material'
import { DiscountDetailLine, ItemDetailAndPrice } from './ItemDetailAndPrice'
import { IDisplayOrderLine } from './interface'
import { VoidDisplay } from './VoidDisplay'
export function LineDetail(
    orderLineDisplay: IDisplayOrderLine & { showAssignTo?: boolean },
) {
    const { showAssignTo } = orderLineDisplay
    const isVoid = Boolean(orderLineDisplay.void)
    return (
        <Grid
            container
            direction="row"
            justifyContent="space-between"
            pr={1}
            color={(x) => (isVoid ? x.palette.disabled.main : undefined)}
        >
            <Grid item xs={1}>
                <Typography>{`${orderLineDisplay.amount}x`}</Typography>
            </Grid>
            <Grid item container xs={11}>
                <Grid item xs={12}>
                    <ItemDetailAndPrice
                        itemName={orderLineDisplay.name!!}
                        subTotal={orderLineDisplay.subTotal}
                        netTotal={orderLineDisplay.netTotal ?? undefined}
                    />
                    <Typography
                        color={(x) =>
                            isVoid
                                ? x.palette.disabled.main
                                : x.palette.bluegrey.main
                        }
                    >
                        {(orderLineDisplay.variants?.length ?? 0) > 0 && (
                            <Grid item container>
                                {orderLineDisplay.variants?.map((op, i) => {
                                    return (
                                        <ItemDetailAndPrice
                                            key={`order-line-display-${op.name}-${i}`}
                                            itemName={op.name!!}
                                            netTotal={op.subTotal}
                                            subTotal={op.subTotal}
                                        />
                                    )
                                })}
                            </Grid>
                        )}
                        {(orderLineDisplay.modifies?.length ?? 0) > 0 && (
                            <Grid item container>
                                {orderLineDisplay.modifies?.map((mod, i) => {
                                    return (
                                        <LineDetail
                                            key={`order-line-modifier-display-${mod.name}-${i}`}
                                            name={mod.name!!}
                                            amount={mod.amount}
                                            netTotal={mod.subTotal}
                                            subTotal={mod.subTotal}
                                            modifies={mod.subModifiers ?? []}
                                        />
                                    )
                                })}
                            </Grid>
                        )}
                        {(orderLineDisplay.subOrderLines?.length ?? 0) > 0 && (
                            <Grid item container>
                                {orderLineDisplay.subOrderLines?.map(
                                    (comboLine, i) => {
                                        return (
                                            <LineDetail
                                                key={`order-line-combo-item-display-${comboLine.name}-${i}`}
                                                {...comboLine}
                                            />
                                        )
                                    },
                                )}
                            </Grid>
                        )}
                    </Typography>
                    {showAssignTo &&
                        (orderLineDisplay.assignTo?.length ?? 0) > 0 && (
                            <Typography fontSize={'12px'} pb={1}>
                                Assign to:{' '}
                                {orderLineDisplay.assignTo?.join(', ')}
                            </Typography>
                        )}
                    {orderLineDisplay.void && (
                        <Grid item>
                            <VoidDisplay {...orderLineDisplay.void} />
                        </Grid>
                    )}
                    {(orderLineDisplay.discounts?.length ?? 0) > 0 && (
                        <Grid item container>
                            {orderLineDisplay.discounts?.map((discount, i) => {
                                return (
                                    <DiscountDetailLine
                                        key={`order-line-combo-item-display-${discount.name}-${i}`}
                                        {...discount}
                                    />
                                )
                            })}
                        </Grid>
                    )}
                    {orderLineDisplay.compDiscount && (
                        <Grid item container>
                            <DiscountDetailLine
                                {...orderLineDisplay.compDiscount}
                            />
                        </Grid>
                    )}
                    {orderLineDisplay.note && (
                        <Grid item container xs={11}>
                            {orderLineDisplay.note}
                        </Grid>
                    )}
                </Grid>
            </Grid>
        </Grid>
    )
}
